<template lang="pug" src="./v-alerts.pug"></template>

<style rel="stylesheet/scss" lang="scss" scoped>
    .errors {
        position: absolute;
        bottom: 20px;
        right: 20px;
        z-index: 3;

        &.mobile {
            top: 50px;
            left: 50%;
            width: 90%;
            bottom: auto;
            right: auto;
            transform: translateX(-50%);
        }
    }
</style>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	computed: {
		...mapGetters([
			'isMobileDevice'
		]),
		...mapState({
			items: state => state.api.messages
		})
	}
}
</script>
